module.exports = {
  blogPostDir: "posts", // The name of directory that contains your posts.
  blogAuthorDir: "authors", // The name of directory that contains your 'blog-authors' folder.
  blogAboutDir: "about", // The name of directory that contains your 'blog-authors' folder.
  blogAuthorId: "progsoc", // The default and fallback author ID used for blog posts without a defined author.
  siteTitle: "ProgSocUTS", // Site title.
  siteTitleAlt: "Programmers' Society UTS", // Alternative site title for SEO.
  siteLogo:
    "/logos/progsoc-logo-reverse.svg", // Logo used for SEO and manifest. e.g. "/logos/logo-1024.png",
  siteUrl: "https://progsoc.org", // Domain of your website without pathPrefix.
  pathPrefix: "/ProgSocUTS", // Prefixes all links. For cases when deployed to example.github.io/gatsby-starter-casper/.
  siteDescription:
    "The Programmers' Society for programmers by programmers of UTS. ", // Website description used for RSS feeds/meta description tag.
  siteSubDescription:
    "Website coming soon, meanwhile reach out to us here", // Optional, will be placed under the website description but will not appear in metadata/SEO
  siteCover:
    "/images/cover_photo1.png", // Optional, the cover image used in header for home page. e.g: "/images/blog-cover.jpg",
  siteNavigation: true, // If navigation is enabled the Menu button will be visible
  siteRss: "/rss.xml", // Path to the RSS file.
  siteRssAuthor: "ProgSoc User", // The author name used in the RSS file
  // siteFBAppID: "1825356251115265", // optional, sets the FB Application ID for using app insights
  sitePaginationLimit: 10, // The max number of posts per page.
  googleAnalyticsID: "UA-111982167-1", // GA tracking ID.
  // disqusShortname: "https-vagr9k-github-io-gatsby-advanced-starter", // enables Disqus comments, visually deviates from original Casper theme.
  siteSocialUrls: [
    "https://www.facebook.com/ProgSoc/",
    "https://discordapp.com/invite/xK7yNH",
    "https://github.com/utsprogsoc",
    "https://twitter.com/ProgSoc_UTS",
    "https://instagram.com/ProgSoc_UTS",
    "http://www.progsoc.uts.edu.au/",
    "mailto:psexec@progsoc.com"
  ],
  postDefaultCategoryID: "Tech", // Default category for posts.
  // Links to social profiles/projects you want to display in the navigation bar.
  userLinks: [
    {
      label: "Facebook",
      url: "https://www.facebook.com/ProgSoc/",
      iconClassName: "fa fa-facebook" // Disabled, see Navigation.jsx
    },
    {
      label: "Discord",
      url: "https://discord.gg/XCAnbVQ",
      iconClassName: "fab fa-discord" // Disabled, see Navigation.jsx
    },
    {
      label: "Twitter",
      url: "https://twitter.com/ProgSoc_UTS",
      iconClassName: "fa fa-twitter" // Disabled, see Navigation.jsx
    },
    {
      label: "Instagram",
      url: "https://instagram.com/ProgSoc_UTS",
      iconClassName: "fa fa-instagram" // Disabled, see Navigation.jsx
    },
    {
      label: "Wiki",
      url: "http://www.progsoc.uts.edu.au/",
      iconClassName: "fa fa-wikipedia" // Disabled, see Navigation.jsx
    },
    {
      label: "Email",
      url: "mailto:president@progsoc.com",
      iconClassName: "fa fa-email" // Disabled, see Navigation.jsx
    },
    {
      label: "GitHub",
      url: "https://github.com/utsprogsoc",
      iconClassName: "fa fa-github" // Disabled, see Navigation.jsx
    },
  ],
  menuLinks: [
    {
      name:'home',
      link:'/'
    }

  ],
  // Copyright string for the footer of the website and RSS feed.
  copyright: {
    label: "Programming Society, UTS.", // Label used before the year
    year: "2019", // optional, set specific copyright year or range of years, defaults to current year
    url: "http://www.progsoc.uts.edu.au/" // optional, set link address of copyright, defaults to site root
  },
  themeColor: "#20208d", // Used for setting manifest and progress theme colors.
  backgroundColor: "#e0e0e0", // Used for setting manifest background color.
  promoteGatsby: true // Enables the GatsbyJS promotion information in footer.
};



// WEBPACK FOOTER //
// ./data/SiteConfig.js